module.exports = __webpack_public_path__ + "static/media/managedService-min.f4d0d2c4.jpg";